const highlights = [
  { icon: 'ri-team-line', value: '50万+', label: '注册用户' },
  { icon: 'ri-image-line', value: '12万+', label: '原创作品' },
  { icon: 'ri-user-star-line', value: '3,000+', label: '认证创作者' },
  { icon: 'ri-thumb-up-line', value: '98%', label: '用户好评率' },
];

export default function CommunityHighlights() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            社区亮点
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            用数据说话，萝幼社正在成为二次元爱好者最喜爱的内容平台
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {highlights.map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center p-6 rounded-lg bg-background-50"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <p className="mt-4 font-heading text-2xl md:text-3xl text-foreground-900">
                {item.value}
              </p>
              <p className="mt-1 text-sm text-foreground-600">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}